export const FORM_FILE_UPLOADS_OUTLET = 'form-file-uploads';

export function hasInvalidFiles(files) {
  if (typeof files === 'undefined') {
    return false;
  }

  if (!Array.isArray(files)) {
    return true;
  }

  return files.some(
    (file) => typeof file !== 'string' || file.trim().length === 0,
  );
}

export function pickEditableSchemaValues(values, schema) {
  const properties = schema?.properties || {};

  return Object.keys(properties).reduce((result, key) => {
    if (
      properties[key]?.readOnly !== true &&
      Object.prototype.hasOwnProperty.call(values, key)
    ) {
      result[key] = values[key];
    }

    return result;
  }, {});
}
